import type { MessengerError } from '../types/responses.js';

export class MessengerAPIError extends Error {
  public readonly code: number;
  public readonly type: string;
  public readonly subcode?: number;
  public readonly fbtrace_id?: string;
  public readonly statusCode: number;
  public readonly response?: any;

  constructor(error: MessengerError, statusCode: number, response?: any) {
    super(error.message);
    this.name = 'MessengerAPIError';
    this.code = error.code;
    this.type = error.type;
    this.subcode = error.error_subcode;
    this.fbtrace_id = error.fbtrace_id;
    this.statusCode = statusCode;
    this.response = response;
  }
}

export class MessengerNetworkError extends Error {
  public readonly cause?: Error;

  constructor(message: string, cause?: Error) {
    super(message);
    this.name = 'MessengerNetworkError';
    this.cause = cause;
  }
}

export class MessengerTimeoutError extends Error {
  public readonly timeout: number;

  constructor(timeout: number) {
    super(`Request timed out after ${timeout}ms`);
    this.name = 'MessengerTimeoutError';
    this.timeout = timeout;
  }
}

export class MessengerConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MessengerConfigError';
  }
}